// src/Components/DashBoard/FirstTimePopup/FirstTimePopup.jsx
import React from 'react';

const FirstTimeUser = ({ setUser }) => {
    const handleOk = () => {
        setUser(true);
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white opacity-80 p-6 rounded-md  w-[80%] h-[80%] shadow-lg relative">
                <h2 className="text-xl font-bold mb-4">You are successfully added as a 'Consumer'</h2>
                <p className="mb-4 font-medium">As a consumer you can use Unified Dev Suite components in four ways:</p>
                <ul className="list-disc ml-6 mb-4">
                    <li>Unified Dev Suite Libraries via npm: Seamlessly integrate components into your projects using Unified Dev Suite Libraries available through npm or documentation portals and access APIs through UDS endpoints. </li>
                    <li>Hosted URLs: Access components directly through hosted URLs available on the playground.</li>
                    <li>Code Snippets: Copy and paste code snippets provided to quickly incorporate functionalities.</li>
                    <li>Download from Azure Artifacts.</li>
                </ul>
                <p className="text-red-600 mb-2">
                    Please click here to get yourself enrolled into MS teams Unified Dev Suite consumers group<br />
                    <a href="https://teams.microsoft.com/l/team/19%3azhmNBmnjyzfJRufd0lfJDW63j5gqZetAZsQTTwEOHr41%40thread.tacv2/conversations?groupId=8043388b-9322-4c0f-a50f-5db8e58bd983&tenantId=311b3378-8e8a-4b5e-a33f-e80a3d8ba60a" target="_blank" className="text-blue-600 underline" rel="noopener noreferrer">Appstudio consumers group</a>
                </p>
                <p className="text-red-600 mb-4">
                    Please click here to enroll yourself into the Azure WebUnified Dev Suite group<br />
                    <a href="https://webappstudio-react.visualstudio.com/" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">Azure webappstudio group</a>
                </p>
                <div className="text-center">
                    <button onClick={handleOk} className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700">OK</button>
                </div>
            </div>
        </div>
    );
};

export default FirstTimeUser;
